module.exports = __webpack_public_path__ + "static/media/logo-mini.cd957e51.svg";